export interface IBaseQueryParams {
  filter: string;
  sort: string;
  pageIndex: number;
  pageSize: number;
  descending: boolean;
  expand: boolean;
}
export class BaseQueryParams {
  public filter: string;
  public sort: string;
  public pageIndex: number;
  public pageSize: number;
  public descending: boolean;
  public expand: boolean;

  constructor(
    filter?: string,
    sort?: string,
    pageIndex?: number,
    pageSize?: number,
    descending?: boolean,
    expand?: boolean,
  ) {
    this.filter = filter ?? '';
    this.sort = sort ?? '';
    this.pageIndex = pageIndex ?? 0;
    this.pageSize = pageSize ?? 10;
    this.descending = descending ?? false;
    this.expand = expand ?? true;
  }

  public update(
    filter?: string,
    sort?: string,
    pageIndex?: number,
    pageSize?: number,
    descending?: boolean,
    expand?: boolean,
  ): void {
    this.filter = filter ?? this.filter;
    this.sort = sort ?? this.sort;
    this.pageIndex = pageIndex ?? this.pageIndex;
    this.pageSize = pageSize ?? this.pageSize;
    this.descending = descending ?? this.descending;
    this.expand = expand ?? this.expand;
  }

  public updateByObject(obj: BaseQueryParams): void {
    this.filter = obj.filter ?? this.filter;
    this.sort = obj.sort ?? this.sort;
    this.pageIndex = obj.pageIndex ?? this.pageIndex;
    this.pageSize = obj.pageSize ?? this.pageSize;
    this.descending = obj.descending ?? this.descending;
    this.expand = obj.expand ?? this.expand;
  }

  public reset(): void {
    this.filter = '';
    this.sort = '';
    this.pageIndex = 0;
    this.pageSize = 100;
    this.descending = false;
    this.expand = true;
  }

  // Create a new object reference to trigger the table component's change detection and refresh its state.
  public clone(): BaseQueryParams {
    return new BaseQueryParams(
      this.filter,
      this.sort,
      this.pageIndex,
      this.pageSize,
      this.descending,
      this.expand,
    );
  }

  /**
   * Returns a new instance of BaseQueryParams with an updated page index.
   * @param {number} pageIndex The new page index.
   * @returns {BaseQueryParams} A new instance with the updated property.
   */
  public withPageIndex(pageIndex: number): BaseQueryParams {
    const newParams = this.clone();
    newParams.pageIndex = pageIndex;
    return newParams;
  }
}
